<template>
  <svg :width="handleSize" :height="handleSize" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 11.9996H6V9.99962H0V0.845618C1.48755e-05 0.758732 0.0226703 0.67335 0.0657334 0.597888C0.108797 0.522425 0.170781 0.459486 0.245577 0.415275C0.320372 0.371063 0.405398 0.347106 0.492273 0.345763C0.579148 0.34442 0.664873 0.365739 0.741 0.407618L19.203 10.5616C19.2814 10.6048 19.3468 10.6682 19.3923 10.7452C19.4378 10.8223 19.4618 10.9101 19.4618 10.9996C19.4618 11.0891 19.4378 11.177 19.3923 11.254C19.3468 11.331 19.2814 11.3945 19.203 11.4376L0.741 21.5916C0.664873 21.6335 0.579148 21.6548 0.492273 21.6535C0.405398 21.6521 0.320372 21.6282 0.245577 21.584C0.170781 21.5397 0.108797 21.4768 0.0657334 21.4013C0.0226703 21.3259 1.48755e-05 21.2405 0 21.1536V11.9996Z" :fill="color" :fill-opacity="fillOpacity"/>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconSend',
  components: {
  },
  props: {
    color: {
      default: '#5138ee',
      type: String
    },
    fillOpacity: {
      default: '0.6',
      type: String
    },
    size: {
      type: String,
      default: 'lg'
    }
  },
  computed: {
    handleSize() {
      switch (this.$props.size) {
        case 'lg': return 20
        case 'md': return 16
        case 'sm': return 14
        case 'xs': return 11
        default: return 20
      }
    }
  }
})
export default class extends Vue {

}
</script>

<style scoped>
</style>
